import { DocumentsModel } from '@common/models/DocumentsModel';
import { MonthlyStatement } from '@services/appsync/types';

import create from 'zustand';

interface StatementViewModelProps {
  isLoading: boolean;
  month: string | null;
  statement: MonthlyStatement | null;
}

interface StatementViewModelActions {
  init: (month: string) => Promise<void>;
  setIsLoading: (isLoading: boolean) => void;
}
export const useStatementViewModel = create<StatementViewModelProps & StatementViewModelActions>((set) => ({
  init: async (month) => {
    const { monthlyStatement } = await DocumentsModel.getState().fetchMonthlyStatement(month);
    set({ isLoading: false, month, statement: monthlyStatement ?? null });
  },
  isLoading: true,
  month: null,
  setIsLoading: (isLoading) => {
    set({ isLoading });
  },
  statement: null,
}));
